var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    id: "instagram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial_147648_827)",
    d: "M24.0018 0C17.4837 0 16.6657 0.0285005 14.1056 0.145C11.5506 0.262 9.8066 0.6665 8.28059 1.26C6.70207 1.873 5.36306 2.693 4.02904 4.0275C2.69403 5.3615 1.87402 6.7005 1.25901 8.2785C0.664007 9.805 0.259003 11.5495 0.144002 14.1035C0.0300004 16.6635 0 17.482 0 24C0 30.518 0.0290008 31.3335 0.145002 33.8935C0.262503 36.4485 0.667007 38.1925 1.26001 39.7185C1.87352 41.297 2.69353 42.636 4.02804 43.97C5.36156 45.305 6.70057 46.127 8.27809 46.74C9.8051 47.3335 11.5496 47.738 14.1041 47.855C16.6642 47.9715 17.4817 48 23.9993 48C30.5178 48 31.3333 47.9715 33.8934 47.855C36.4484 47.738 38.1944 47.3335 39.7214 46.74C41.2994 46.127 42.6364 45.305 43.97 43.97C45.305 42.636 46.125 41.297 46.74 39.719C47.33 38.1925 47.735 36.448 47.855 33.894C47.97 31.334 48 30.518 48 24C48 17.482 47.97 16.664 47.855 14.104C47.735 11.549 47.33 9.805 46.74 8.279C46.125 6.7005 45.305 5.3615 43.97 4.0275C42.6349 2.6925 41.2999 1.8725 39.7199 1.26C38.1899 0.6665 36.4449 0.262 33.8899 0.145C31.3298 0.0285005 30.5148 0 23.9947 0H24.0018ZM21.8487 4.325C22.4877 4.324 23.2007 4.325 24.0018 4.325C30.4098 4.325 31.1693 4.348 33.6999 4.463C36.0399 4.57 37.3099 4.961 38.1559 5.2895C39.2759 5.7245 40.0744 6.2445 40.9139 7.0845C41.7539 7.9245 42.2739 8.7245 42.7099 9.8445C43.0385 10.6895 43.43 11.9595 43.5365 14.2995C43.6515 16.8295 43.6765 17.5895 43.6765 23.9945C43.6765 30.3995 43.6515 31.1595 43.5365 33.6895C43.4295 36.0295 43.0385 37.2995 42.7099 38.1445C42.2749 39.2645 41.7539 40.062 40.9139 40.9015C40.0739 41.7415 39.2764 42.2615 38.1559 42.6965C37.3109 43.0265 36.0399 43.4165 33.6999 43.5235C31.1698 43.6385 30.4098 43.6635 24.0018 43.6635C17.5932 43.6635 16.8337 43.6385 14.3036 43.5235C11.9636 43.4155 10.6936 43.0245 9.8471 42.696C8.72709 42.261 7.92708 41.741 7.08707 40.901C6.24707 40.061 5.72706 39.263 5.29106 38.1425C4.96255 37.2975 4.57105 36.0275 4.46455 33.6875C4.34955 31.1575 4.32655 30.3975 4.32655 23.9885C4.32655 17.5795 4.34955 16.8235 4.46455 14.2935C4.57155 11.9535 4.96255 10.6835 5.29106 9.8375C5.72606 8.7175 6.24707 7.9175 7.08707 7.0775C7.92708 6.2375 8.72709 5.7175 9.8471 5.2815C10.6931 4.9515 11.9636 4.5615 14.3036 4.454C16.5177 4.354 17.3757 4.324 21.8487 4.319V4.325Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial_147648_827)",
    d: "M36.7613 8.25105C36.1916 8.25105 35.6348 8.41998 35.1611 8.73648C34.6875 9.05299 34.3183 9.50284 34.1004 10.0291C33.8824 10.5555 33.8254 11.1346 33.9367 11.6933C34.0479 12.252 34.3223 12.7651 34.7251 13.1679C35.128 13.5706 35.6413 13.8448 36.2 13.9558C36.7588 14.0668 37.3379 14.0097 37.8641 13.7915C38.3903 13.5734 38.8401 13.2041 39.1564 12.7304C39.4728 12.2566 39.6415 11.6997 39.6413 11.13C39.6413 9.54005 38.3513 8.25005 36.7613 8.25005V8.25105Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_radial_147648_827)",
    fillRule: "evenodd",
    d: "M23.9501 11.616C17.1436 11.616 11.625 17.1345 11.625 23.941C11.625 30.7475 17.1436 36.2635 23.9501 36.2635C30.7567 36.2635 36.2738 30.7475 36.2738 23.941C36.2738 17.1345 30.7567 11.616 23.9501 11.616ZM24 31.875C28.3493 31.875 31.875 28.3493 31.875 24C31.875 19.6508 28.3493 16.125 24 16.125C19.6508 16.125 16.125 19.6508 16.125 24C16.125 28.3493 19.6508 31.875 24 31.875Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_radial_147648_827)",
    d: "M24.0018 0C17.4837 0 16.6657 0.0285005 14.1056 0.145C11.5506 0.262 9.8066 0.6665 8.28059 1.26C6.70207 1.873 5.36306 2.693 4.02904 4.0275C2.69403 5.3615 1.87402 6.7005 1.25901 8.2785C0.664007 9.805 0.259003 11.5495 0.144002 14.1035C0.0300004 16.6635 0 17.482 0 24C0 30.518 0.0290008 31.3335 0.145002 33.8935C0.262503 36.4485 0.667007 38.1925 1.26001 39.7185C1.87352 41.297 2.69353 42.636 4.02804 43.97C5.36156 45.305 6.70057 46.127 8.27809 46.74C9.8051 47.3335 11.5496 47.738 14.1041 47.855C16.6642 47.9715 17.4817 48 23.9993 48C30.5178 48 31.3333 47.9715 33.8934 47.855C36.4484 47.738 38.1944 47.3335 39.7214 46.74C41.2994 46.127 42.6364 45.305 43.97 43.97C45.305 42.636 46.125 41.297 46.74 39.719C47.33 38.1925 47.735 36.448 47.855 33.894C47.97 31.334 48 30.518 48 24C48 17.482 47.97 16.664 47.855 14.104C47.735 11.549 47.33 9.805 46.74 8.279C46.125 6.7005 45.305 5.3615 43.97 4.0275C42.6349 2.6925 41.2999 1.8725 39.7199 1.26C38.1899 0.6665 36.4449 0.262 33.8899 0.145C31.3298 0.0285005 30.5148 0 23.9947 0H24.0018ZM21.8487 4.325C22.4877 4.324 23.2007 4.325 24.0018 4.325C30.4098 4.325 31.1693 4.348 33.6999 4.463C36.0399 4.57 37.3099 4.961 38.1559 5.2895C39.2759 5.7245 40.0744 6.2445 40.9139 7.0845C41.7539 7.9245 42.2739 8.7245 42.7099 9.8445C43.0385 10.6895 43.43 11.9595 43.5365 14.2995C43.6515 16.8295 43.6765 17.5895 43.6765 23.9945C43.6765 30.3995 43.6515 31.1595 43.5365 33.6895C43.4295 36.0295 43.0385 37.2995 42.7099 38.1445C42.2749 39.2645 41.7539 40.062 40.9139 40.9015C40.0739 41.7415 39.2764 42.2615 38.1559 42.6965C37.3109 43.0265 36.0399 43.4165 33.6999 43.5235C31.1698 43.6385 30.4098 43.6635 24.0018 43.6635C17.5932 43.6635 16.8337 43.6385 14.3036 43.5235C11.9636 43.4155 10.6936 43.0245 9.8471 42.696C8.72709 42.261 7.92708 41.741 7.08707 40.901C6.24707 40.061 5.72706 39.263 5.29106 38.1425C4.96255 37.2975 4.57105 36.0275 4.46455 33.6875C4.34955 31.1575 4.32655 30.3975 4.32655 23.9885C4.32655 17.5795 4.34955 16.8235 4.46455 14.2935C4.57155 11.9535 4.96255 10.6835 5.29106 9.8375C5.72606 8.7175 6.24707 7.9175 7.08707 7.0775C7.92708 6.2375 8.72709 5.7175 9.8471 5.2815C10.6931 4.9515 11.9636 4.5615 14.3036 4.454C16.5177 4.354 17.3757 4.324 21.8487 4.319V4.325Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_radial_147648_827)",
    d: "M36.7613 8.25105C36.1916 8.25105 35.6348 8.41998 35.1611 8.73648C34.6875 9.05299 34.3183 9.50284 34.1004 10.0291C33.8824 10.5555 33.8254 11.1346 33.9367 11.6933C34.0479 12.252 34.3223 12.7651 34.7251 13.1679C35.128 13.5706 35.6413 13.8448 36.2 13.9558C36.7588 14.0668 37.3379 14.0097 37.8641 13.7915C38.3903 13.5734 38.8401 13.2041 39.1564 12.7304C39.4728 12.2566 39.6415 11.6997 39.6413 11.13C39.6413 9.54005 38.3513 8.25005 36.7613 8.25005V8.25105Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_radial_147648_827)",
    fillRule: "evenodd",
    d: "M23.9501 11.616C17.1436 11.616 11.625 17.1345 11.625 23.941C11.625 30.7475 17.1436 36.2635 23.9501 36.2635C30.7567 36.2635 36.2738 30.7475 36.2738 23.941C36.2738 17.1345 30.7567 11.616 23.9501 11.616ZM24 31.875C28.3493 31.875 31.875 28.3493 31.875 24C31.875 19.6508 28.3493 16.125 24 16.125C19.6508 16.125 16.125 19.6508 16.125 24C16.125 28.3493 19.6508 31.875 24 31.875Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_147648_827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -47.5715 44.2453 0 12.75 51.697)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_147648_827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -47.5715 44.2453 0 12.75 51.697)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_147648_827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -47.5715 44.2453 0 12.75 51.697)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_147648_827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.17365 20.8511 -85.949 17.20395 -8.041 3.458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_147648_827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.17365 20.8511 -85.949 17.20395 -8.041 3.458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_147648_827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.17365 20.8511 -85.949 17.20395 -8.041 3.458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIconSelected);
export default __webpack_public_path__ + "static/media/instagramIconSelected.e19279eab7754227697ceafe6f353cc9.svg";
export { ForwardRef as ReactComponent };